import React, { useMemo } from 'react'
import { Box, Text, AddIconWMO } from '@usap/uicomponents'
import ImageUpload from './ImageUpload'
import { Heading5 } from '../../../../common/heading'
import { AddMoreBox, AddMoreContainer, AddMoreText } from '../style/ImageGalleryItemWMO.css'

const ImageGalleryItemWMO = props => {
  const {
    widgets,
    onChange,
    formFile = {},
    isDesktop,
    removeImage,
    errorSteps,
    selectedPart,
    threshold,
    setThreshold
  } = props

  const requiredData = widgets.required
    ? ''
    : ' <span style="font-size: 16px; color: #5C5C5C; font-weight: 400">(Optional)</span>'

  const headerText = `${widgets.title}${requiredData}`

  const addMore = useMemo(
    () => {
      const checkCurrentUploadedFile = widgets.props?.filter(x => formFile[x.id])
      const disabled = Object.keys(checkCurrentUploadedFile).length < threshold

      if (threshold >= widgets.props.length) return null

      return (
        <AddMoreContainer
          isDesktop={isDesktop}
          disabled={disabled}
        >
          <AddMoreBox
            isDesktop={isDesktop}
            disabled={disabled}
            onClick={
              () => setThreshold(prev => (!disabled
                && prev < widgets.props.length ? prev + 1 : prev))
            }
          >
            <AddIconWMO />
          </AddMoreBox>
          <AddMoreText>
            Add More
          </AddMoreText>
        </AddMoreContainer>
      )
    }, [formFile, widgets, threshold, isDesktop],
  )

  return (
    <Box>
      <Heading5
        width="large"
        key={widgets.id}
        title={headerText}
        size={isDesktop ? '16px' : '14px'}
        color="dark-2"
        style={{ fontWeight: 500, maxWidth: '100%' }}
        margin={{ bottom: '8px', top: '0px' }}
      />

      {widgets.subtitle && (
        <Box alignContent="start" alignSelf="start">
          <Text color="dark-2" style={{ fontSize: "14px", fontWeight: 400}}>{widgets.subtitle}</Text>
        </Box>
      )}

      <Text id={`error-${widgets.id}`} style={{ color: '#f90000', fontSize: '12px' }}>
        {errorSteps[widgets.id]}
      </Text>

      <Box
        direction="row"
        alignContent="start"
        alignSelf="start"
        margin={{ top: '16px', bottom: "24px" }}
        style={{
          flexFlow: 'row wrap',
          gap: '16px'
        }}
      >
        {widgets.props.map((attr, index) => index + 1 <= threshold
            && (
            <ImageUpload
              isDesktop={isDesktop}
              key={`${widgets.id}-${attr.id}`}
              attr={attr}
              widgets={widgets}
              onChange={onChange}
              removeImage={removeImage}
              formFile={formFile}
              selectedPart={selectedPart}
              required={widgets.required}
            />
            ))}
        {addMore}
      </Box>
    </Box>
  )
}

export default ImageGalleryItemWMO
